import { Box } from '@mui/material';
import { alpha, darken } from '@mui/material/styles';
import useTenant from '../hooks/useTenant';

const KONQ_ESCURO = '#0A0A0A';

/**
 * Fundo das áreas de marca (painel do login/cadastro, hero da landing). Ocupa o
 * pai inteiro (position absolute) — o pai precisa de position relative/sticky.
 *
 * - Tenant com imagem de fundo no branding (`imagemFundoUrl`): a foto, com overlay escuro.
 * - Sem imagem: fundo neutro do Konq, gradiente na cor primária do tenant (ou preto
 *   HZero) com uma grade sutil — nada de foto fixa de produto ou de cliente.
 *
 * `direcao` controla de onde o escurecimento vem ("baixo" no painel, "esquerda" no hero).
 */
export default function FundoMarca({ direcao = 'baixo' }) {
  const { branding } = useTenant();
  const imagem = branding?.imagemFundoUrl || null;
  const cor = branding?.corPrimaria || KONQ_ESCURO;
  const sentido = direcao === 'esquerda' ? '100deg' : 'to top';

  return (
    <>
      {imagem ? (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url("${imagem}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'saturate(0.5)',
          }}
        />
      ) : (
        <Box
          sx={{
            'position': 'absolute',
            'inset': 0,
            'background': `radial-gradient(120% 80% at 85% 10%, ${alpha(cor, 0.9)} 0%, ${darken(cor, 0.55)} 55%, ${KONQ_ESCURO} 100%)`,
            // grade sutil
            '&::after': {
              content: '""',
              position: 'absolute',
              inset: 0,
              backgroundImage:
                'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)',
              backgroundSize: '48px 48px',
              maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.9), transparent 85%)',
            },
          }}
        />
      )}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: imagem
            ? `linear-gradient(${sentido}, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.6) 45%, rgba(0,0,0,0.35) 100%)`
            : `linear-gradient(${sentido}, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 60%)`,
        }}
      />
    </>
  );
}
